// udp-menu-item.tsx
import { Component, Prop, h, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'udp-menu-item',
  styleUrl: 'udp-menu-item.css',
  shadow: true
})
export class UdpMenuItem {
  @Prop() label: string;
  @Prop() handleOnClick: (e: Event) => void;
  @Prop() iconName: string;
  @Prop() disabled: boolean = false;

  @Event() itemClick: EventEmitter;

  handleItemClick = (e: Event) => {
    if (this.handleOnClick) {
      this.handleOnClick(e);
    }
    this.itemClick.emit();
  }

  render() {
    return (
      <div 
        class="menu-item-root" 
        onClick={this.handleItemClick}
        id={"udpRecord-udp-menu-item-ItemClick"}
        //@ts-ignore
        udprecordid={"udpRecord-udp-menu-item-ItemClick"}
        disabled={this.disabled}
      >
        {this.iconName && <udp-icon iconName={this.iconName} class="menu-icon"/>}
        <span class="menu-item-label">
         <unity-typography variant='button' > {this.label} </unity-typography> 
        </span>
      </div>
    );
  }
}
